import dataURItoBlob from '../data-uri-to-blob';
import { guidFor } from '@ember/object/internals';
import { updateImageNodeWithProcessingResult, processImageFile } from '../../helpers/image';
import { updateNodeWithUploadResult } from '../../helpers/file';
import { isUrl } from './../../helpers/is-url';
export default function transformPastedSlice(slice, composer, editorView) {
  slice = stripNonBreakingSpaces(slice);
  slice = processPastedHtmlImages(slice, composer, editorView);
  return slice;
}
function stripNonBreakingSpaces(slice) {
  slice.content.nodesBetween(0, slice.content.size, node => {
    if (node.text && node.text.length > 0) {
      node.text = node.text.replace(/\u00A0/g, ' ');
    }
  });
  return slice;
}
function processPastedHtmlImages(slice, composer, editorView) {
  slice.content.forEach(async node => {
    if (composer.config.upload && node.type.name === 'image' && !node.attrs.fileGUID) {
      let allowedTypes = composer.config.upload.allowedImageFileTypes;
      let allowTypesRegex = allowedTypes.includes('*') ? 'image/(?:jpg|jpeg|png|gif)' : `(${allowedTypes.join('|').replace('/', '/')})`;
      let base64Regex = `^data:${allowTypesRegex};base64.*`;
      let validImage = node.attrs.src.match(new RegExp(base64Regex));

      // send the file URL to the upload endpoint if the source is a third party URL
      if (isUrl(node.attrs.src)) {
        let url = node.attrs.src;
        let guid = guidFor(url);
        node.attrs.fileGUID = guid;
        let uploadResult = await composer.commands.doUploadFromUrl(url);
        updateNodeWithUploadResult(editorView, uploadResult, guid);
      }
      if (validImage) {
        let file = dataURItoBlob(node.attrs.src);
        let tempURL = window.URL.createObjectURL(file);
        let guid = guidFor(file);
        file.name = tempURL.split('/').pop();
        node.attrs.src = tempURL;
        node.attrs.fileGUID = guid;
        let processingResult = await processImageFile(file);
        updateImageNodeWithProcessingResult(editorView, processingResult);
        let uploadResult = await composer.commands.doUpload(processingResult.file);
        updateNodeWithUploadResult(editorView, uploadResult);
      }
    }
  });
  return slice;
}